export const errorCodeHandler = (context, error) => {
  if (error === 'DUPLICATE_BOOKING_NOT_ACKNOWLEDGED') {
    context.commit('setDuplicateBooking', true);

    return false;
  }


  return true;
};
